export const usStates = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "NewHampshire",
  "New Jersey",
  "NewJersey",
  "New Mexico",
  "NewMexico",
  "New York",
  "NewYork",
  "North Carolina",
  "NorthCarolina",
  "North Dakota",
  "NorthDakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "PuertoRico",
  "Rhode Island",
  "RhodeIsland",
  "South Carolina",
  "SouthCarolina",
  "South Dakota",
  "SouthDakota",
  "Tennessee",
  "Texas",
  "US Virgin",
  "USVirgin",
  "U\\.S\\. Virgin",
  "U\\.S\\.Virgin",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "WestVirginia",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const usStateAbbrevs = [
  "AL",
  "Al",
  "Ala",
  "AK",
  "Ak",
  "AZ",
  "Az",
  "Ariz",
  "AR",
  "Ar",
  "Ark",
  "CA",
  "Ca",
  "Cali",
  "Calif",
  "Co",
  "Colo",
  "CT",
  "Ct",
  "Conn",
  "De",
  "Del",
  "FL",
  "Fl",
  "Fla",
  "GA",
  "Ga",
  "HI",
  "ID",
  "Id",
  "IL",
  "Il",
  "Ill",
  "Ind",
  "IA",
  "Ia",
  "KS",
  "Ks",
  "Kan",
  "Kans",
  "KY",
  "Ky",
  "LA",
  "La",
  "MD",
  "Md",
  "MI",
  "Mi",
  "Mich",
  "MN",
  "Mn",
  "Minn",
  "MS",
  "Ms",
  "Miss",
  "MO",
  "Mo",
  "MT",
  "Mt",
  "Mont",
  "NE",
  "Ne",
  "Neb",
  "Nebr",
  "NV",
  "Nv",
  "Nev",
  "NH",
  "Nh",
  "N\\.H",
  "NJ",
  "Nj",
  "N\\.J",
  "NM",
  "Nm",
  "N\\.M",
  "NMex",
  "N\\. Mex",
  "N\\.Mex",
  "NY",
  "Ny",
  "N\\.Y",
  "NC",
  "Nc",
  "N\\.C",
  "ND",
  "Nd",
  "N\\.D",
  "N\\. Dak",
  "N\\.Dak",
  "Ohio",
  "OH",
  "Oh",
  "Okla",
  "OR",
  "Or",
  "Ore",
  "Oreg",
  "Org",
  "PA",
  "Pa",
  "Penn",
  "PR",
  "Pr",
  "RI",
  "Ri",
  "R\\.I",
  "SC",
  "Sc",
  "S\\.C",
  "SD",
  "Sd",
  "S\\.D",
  "S\\. Dak",
  "S\\.Dak",
  "TN",
  "Tn",
  "Tenn",
  "Texas",
  "TX",
  "Tx",
  "Tex",
  "USVI",
  "VI",
  "Vi",
  "Utah",
  "UT",
  "Ut",
  "VT",
  "Vt",
  "VA",
  "Va",
  "WA",
  "Wa",
  "Wash",
  "WV",
  "Wv",
  "WVA",
  "W\\.Va",
  "W\\. Va",
  "WI",
  "Wi",
  "Wis",
  "WY",
  "Wy",
  "Wyo",
];
